import React from 'react';

type CardVariant = 'default' | 'interactive' | 'alert' | 'glass';

export interface CardProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'children'> {
  variant?: CardVariant;
  className?: string;
  children: React.ReactNode;
  onClick?: () => void;
}

const VARIANT_STYLES: Record<CardVariant, string> = {
  default:
    'p-4 rounded-xl border border-subtle bg-surface-primary',
  interactive:
    'p-4 rounded-xl border border-subtle bg-surface-primary hover:border-default hover:bg-surface-secondary transition-all cursor-pointer',
  alert:
    'p-4 rounded-xl border border-red-400/15 bg-red-400/[0.04]',
  glass:
    'p-4 rounded-xl border border-subtle bg-surface-glass backdrop-blur-md',
};

const Card = React.forwardRef<HTMLDivElement, CardProps>(
  (
    {
      variant = 'default',
      className = '',
      children,
      onClick,
      ...rest
    },
    ref,
  ) => {
    const classes = [VARIANT_STYLES[variant], className].filter(Boolean).join(' ');

    return (
      <div ref={ref} className={classes} onClick={onClick} {...rest}>
        {children}
      </div>
    );
  },
);

Card.displayName = 'Card';

export default Card;
